import { bindActionCreators } from "@reduxjs/toolkit";
import { SUBSOURCE } from "constant";
import { ScanYearOldDto } from "dto/vending/ScanYearOldDto";
import moment from "moment";
import React, { Component } from 'react';
import { connect, ConnectedProps } from "react-redux";
import stompClient from 'service/webStomp.service';
import appActions from "store/app/app.actions";



const stateToProps = () => {
	return {};
}

const dispatchToProps = (dispatch: any) => bindActionCreators({
	lastDataScanYearOld: appActions.lastDataScanYearOld,
}, dispatch);


const connector = connect(stateToProps, dispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & {};

type States = {
	code: string,
	messages: Array<any>,
}

class HanldeWebStomp extends Component<Props, States> {
	subscription = null;
	constructor(props: Props) {
		super(props);
		this.state = {
			code: "",
			messages: [],
		};
	}

	componentDidMount() {
		let query = new URLSearchParams(window.location.search);
		const code = query.get("code");
		const subsource = query.get("subsource");
		if (code && subsource === SUBSOURCE.VM) {
			this.setState({
				code: code
			}, () => {
				this.connect();
			});
		}
	}

	componentWillUnmount() {
		stompClient.disconnect();
	}

	connect = () => {
		stompClient.connect(
			this.onConnected,
			this.onError
		);
	};

	onConnected = () => {
		console.log('Connected to STOMP');
		this.subscription = stompClient.subscribe(`/queue/DETECT_TO_SALE_${this.state.code}`, this.onMessageReceived);
	};

	onError = (error: string) => {
		console.log('Error: ' + error);
	};

	onMessageReceived = (message: { body: any; }) => {
		console.log("message.body", message.body);
		// {"number": 1, "users": [{"ageRange": "(25-32)", "gender": "Male"}], "localTime": "2024-11-06T06:40:33.402889Z"}
		if (message.body) {
			try {
				let json = JSON.parse(message.body);
				if (Number(json.number) > 0 && json.users && json.users.length > 0) {
					let first = new ScanYearOldDto();
					first.faceNumber = json.number;
					first.gender = json.users[0].gender;
					first.ageRange = json.users[0].ageRange;
					first.ageRange = json.users[0].ageRange;
					if (json.localTime) {
						first.localTime = moment(json.localTime);
					}
					this.props.lastDataScanYearOld(first);
				}
			} catch (error) { }
		}
	};

	// sendMessage = () => {
	// 	stompClient.send(`/queue/DETECT_TO_SALE_${this.state.code}`, "mess send here");
	// };

	render() {
		return (
			<React.Fragment></React.Fragment>
		);
	}
}

export default connector(HanldeWebStomp);
